import { MenuDivider } from "@blueprintjs/core"
import ActionMenu from "components/Organisms/ActionMenu"
import ActionMenuItem from "components/Organisms/ActionMenuItem"
import React, { useState } from "react"
import SalesOrderEditUpdate from "./SalesOrderEditUpdate"

export default function SoActions({ soId, refetch }) {
  const [isEditOpen, toggleEdit] = useState(false)
  const handleSelect = id => {
    switch (id) {
      case "edit":
        toggleEdit(true)
        break
      case "delete":
        break
      default:
        break
    }
  }
  return (
    <>
      <ActionMenu minimal={true} icon="more" text={null} onClick={handleSelect}>
        <ActionMenuItem icon="edit" text="Edit" />
      </ActionMenu>
      <SalesOrderEditUpdate
        isOpen={isEditOpen}
        soId={soId}
        onClose={e => {
          toggleEdit(false)
          refetch()
        }}
      />
    </>
  )
}
